export function groupProductsByRow(products, noOfProductsPerRow) {
  return products.reduce((rows, product) => {
    const currentRow = rows[rows.length - 1];

    if (product.fullWidth) {
      if (!currentRow.length) {
        currentRow.push(product);
        rows.push([]);
      } else {
        // Create new row for fullWidth product and an empty row after it
        rows.push([product], []);
      }
    } else if (currentRow.length < noOfProductsPerRow) {
      // Add product to current row if there's space
      currentRow.push(product);
    } else {
      // Create new row for the product
      rows.push([product]);
    }

    return rows;
  }, [[]]);
}

export default groupProductsByRow;
